import React, { useContext, useState, useRef, useEffect } from 'react';
import axios from 'axios';
import UserContext from '../UserContext/UserContext';
import { IdleTimeOutModal } from '../modal/IdleModal';
import IdleTimer from 'react-idle-timer';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import bell from './../../fsa-style/img/svgs/bell.svg';
import './head.scss';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { EventEmitter } from '../../services/events';
import { useAuth } from 'react-oidc-context';

import { getSystemConfigDetails } from '../../services/inBasketService';
import High_msg from '../../fsa-style/img/svgs/high_message.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { GlobalLoader } from '../../newcomponents/GlobalLoader/GlobalLoader';
import User_Guide from './../../fsa-style/img/svgs/User_guide3.svg';
const Head = ({ logout }) => {
  const [showModal, setShowModal] = useState(false);
  const idleTimerRef = useRef(null);
  const sessionTimeoutRef = useRef(null);

  const [path, setPath] = useState(window.location.pathname);
  const { messages, buowDetails } = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [systemConfig, setSystemConfig] = useState((window.localStorage.getItem('system_config') && JSON.parse(window.localStorage.getItem('system_config'))) || {});
  const [hoveredNoteIndex, setHoveredNoteIndex] = useState(null);

  const user = JSON.parse(sessionStorage.getItem('user') || '{}');

  const loginUserName = user?.profile?.preferred_username || user?.profile?.name || '';

  const contextId = window.env.REACT_APP_CLIENT_CONTEXT_ID;
  const location = useLocation();
  const auth = useAuth();
  const updatedStateOnLocalStorage = () => {
    setSystemConfig(window.localStorage.getItem('system_config') && JSON.parse(window.localStorage.getItem('system_config')));
  };
  useEffect(() => {
    updatedStateOnLocalStorage();

    EventEmitter.on('LocalStorageUpdated', updatedStateOnLocalStorage);

    return () => {
      EventEmitter.off('LocalStorageUpdated', updatedStateOnLocalStorage);
    };
  }, []);

  useEffect(() => {
    const handlePageHide = () => {
      const stored = sessionStorage.getItem('user');
      if (!stored) return;
      try {
        const refreshToken = JSON.parse(stored)?.refresh_token;
        const clientId = window.env.REACT_APP_IDP_SPA_CLIENT_ID;
        const idpUrl = window.env.REACT_APP_IDP_SPA_URL;
        if (refreshToken && clientId && idpUrl && navigator.sendBeacon) {
          const body = `token=${encodeURIComponent(refreshToken)}&client_id=${encodeURIComponent(clientId)}`;
          const blob = new Blob([body], { type: 'application/x-www-form-urlencoded' });
          navigator.sendBeacon(`${idpUrl.replace(/\/$/, '')}/oauth2/revoke`, blob);
        }
      } catch (e) { }
    };
    window.addEventListener('pagehide', handlePageHide);
    return () => window.removeEventListener('pagehide', handlePageHide);
  }, []);

  useEffect(() => {
    setPath(window.location.pathname);
  }, [location, path, buowDetails, sessionStorage.getItem('authorizationToken')]);
  useEffect(() => {
    if (Object.keys(systemConfig).length === 0) {
      updateSysConfig();
    }
  }, []);

  const updateSysConfig = async () => {
    let response = await getSystemConfigDetails(contextId);
    setSystemConfig(response?.data);
  };
  useEffect(() => {
    if (Object.keys(systemConfig).length === 0) {
      updateSysConfig();
    }
  }, []);

  const handleOnIdle = () => {
    loggingOut();
  };
  const handleClose = () => {
    setShowModal(false);
    clearTimeout(sessionTimeoutRef.current);
  };

  const popover = (
    <Popover id="popover-contained" style={{ maxWidth: 'initial', width: '450px', height: '350px', fontSize: '15px', overflowY: 'scroll' }} role="contentinfo">
      <Popover.Header style={{ fontSize: '15px', textAlign: 'center' }}>Messages</Popover.Header>
      <Popover.Body>
        {messages &&
          messages.map((obj, idx) => {
            return (
              <div
                onMouseEnter={() => setHoveredNoteIndex(idx)}
                onMouseLeave={() => setHoveredNoteIndex(null)}
                style={{
                  backgroundColor: hoveredNoteIndex === idx ? '#D6E7EE7D' : 'transparent',
                }}
                className="popBody"
                key={`${idx}_head_msg`}
              >
                <strong
                  style={{
                    color: hoveredNoteIndex === idx ? '#406AB7' : 'inherit',
                  }}
                >
                  {obj.userName}
                </strong>
                <span style={{ color: hoveredNoteIndex == idx ? '#406AB7' : 'inherit' }}>{` has added `}</span>
                <br />
                {obj.priority === 'H' && <img src={High_msg} alt="High_msg" style={{ height: 30 }} />}
                <span style={{ color: hoveredNoteIndex == idx ? '#406AB7' : 'inherit' }}>{` ${obj?.messageBody}`}</span>

                <p style={{ color: hoveredNoteIndex == idx ? '#406AB7' : '' }} className="popBody__date">
                  {moment.utc(obj.messageDttm.split('T').join(' ')).local().format('YYYY-MM-DD hh:mm:ss A')}
                </p>
              </div>
            );
          })}
      </Popover.Body>
    </Popover>
  );

  const loggingOut = async () => {
    try {
      await auth.revokeTokens();
    } catch (e) { }
    sessionStorage.clear();
    localStorage.clear();
    await auth.removeUser();
    await auth.signoutRedirect({
      extraQueryParams: {
        logout_uri: window.location.origin + '/login',
      },
    });
    setIsLoading(false);
  };

  const onSelectUserName = () => {
    navigate('/profile');
  };
  const downloadUserGuide = async () => {
    try {
      const response = await axios.get(`${window.env.REACT_APP_BACKEND_URL}/aws_s3_api/s3/${window.env.REACT_APP_S3_USER_GUIDE_BUCKET_NAME}/TEGE Redaction System User Guide.pdf`, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'TEGE Redaction System User Guide.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading the user guide:', error);
    }
  };

  return (
    <>
      {isLoading && <GlobalLoader />}

      <IdleTimer ref={idleTimerRef} element={document} onIdle={handleOnIdle} debounce={250} timeout={parseInt(window.env.REACT_APP_TIME_OUT)} />
      <header>
        <div className="fsa-tophat fsa-tophat--fullscreen">
          <div className="fsa-tophat__bd" style={{ marginLeft: '2em', marginRight: '2em' }}>
            <div className="fsa-tophat__primary">
              <span className="fsa-tophat__agency">
                <a href="/" style={{ textDecoration: 'none' }}>
                  <div className="fsa-tophat__link style_hover">
                    {systemConfig !== null && (
                      <>
                        {systemConfig?.logo && <img className="fsa-tophat__agency-logo" src={`data:image/jpeg;base64,${systemConfig?.logo}`} alt="System Configuration logo" />}
                        <span
                          className="fsa-tophat__agency-fullname style_hover"
                          style={{
                            fontSize: '14px',
                            paddingRight: 5,
                          }}
                        >
                          {systemConfig?.title}
                        </span>{' '}
                        {window.env.REACT_APP_ENVIRONMENT === 'UAT' && (
                          <span style={{ color: 'black', borderLeft: '1px solid #DCDCDC', paddingLeft: 6, fontWeight: 800, fontSize: 18 }}>SMC UAT</span>
                        )}
                        {window.env.REACT_APP_ENVIRONMENT === 'DRIMS Demo' && (
                          <span style={{ color: 'black', borderLeft: '1px solid #DCDCDC', paddingLeft: 6, fontWeight: 800, fontSize: 18 }}>TEGE Redaction System</span>
                        )}
                        {window.env.REACT_APP_ENVIRONMENT === 'DRIMS Dev' && (
                          <span style={{ color: 'black', borderLeft: '1px solid #DCDCDC', paddingLeft: 6, fontWeight: 800, fontSize: 18 }}>DRIMS Dev</span>
                        )}
                        {window.env.REACT_APP_ENVIRONMENT === 'DRIMS QA' && (
                          <span style={{ color: 'black', borderLeft: '1px solid #DCDCDC', paddingLeft: 6, fontWeight: 800, fontSize: 18 }}>DRIMS QA</span>
                        )}
                        {window.env.REACT_APP_ENVIRONMENT === 'Dev' && (
                          <span style={{ color: 'black', borderLeft: '1px solid #DCDCDC', paddingLeft: 6, fontWeight: 800, fontSize: 18 }} className="style_hover">
                            TEGE Redaction System
                          </span>
                        )}
                        {window.env.REACT_APP_ENVIRONMENT === 'QA' && (
                          <span style={{ color: 'black', borderLeft: '1px solid #DCDCDC', paddingLeft: 6, fontWeight: 800, fontSize: 18 }} className="style_hover">
                            TEGE Redaction System
                          </span>
                        )}
                        {window.env.REACT_APP_ENVIRONMENT === 'PREPROD' && (
                          <span style={{ color: 'black', borderLeft: '1px solid #DCDCDC', paddingLeft: 6, fontWeight: 800, fontSize: 18 }}>ALICE REDAX</span>
                        )}
                      </>
                    )}
                  </div>
                </a>
              </span>
            </div>
            <div className="fsa-tophat__secondary row d-flex align-items-center">
              <OverlayTrigger trigger={'click'} rootClose placement="bottom" overlay={popover}>
                <button className="message-btn style_hover" style={{ marginRight: '0.6rem' }}>
                  <div className="headTextOuterDiv row mt-2 mr-5" style={{ cursor: 'pointer' }}>
                    <span className="headText" style={{ margin: '0px 20px' }}>
                      {'Messages'}
                    </span>
                    <div className="row">
                      <img src={bell} alt="Message Notification Icon" className="headIcon" style={{ width: '14px', height: '17px' }} />
                      <div className="messageCount">
                        <span>{messages?.length}</span>
                      </div>
                    </div>
                  </div>
                </button>
              </OverlayTrigger>
              {window.env.REACT_APP_GUIDE_VISIBLE === 'false' || window.env.REACT_APP_GUIDE_VISIBLE === false ? (
                <></>
              ) : (
                <>
                  {window.env.REACT_APP_FE_ENVIRONMENT !== undefined ? (
                    <></>
                  ) : (
                    <button
                      aria-label="User Guide"
                      tabIndex={0}
                      className="user_guide_button"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') downloadUserGuide();
                      }}
                    >
                      <img src={User_Guide} alt="user_guide_icon" className="user_guide_icon cursor style_hover" title="User Guide" onClick={downloadUserGuide} />
                    </button>
                  )}
                  {systemConfig !== null && <span> User Guide</span>}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="fsa-header-app fsa-header-app--fullscreen" style={{ backgroundColor: '#187CBE' }}>
          <div className="fsa-header-app__bd p-2 pl-5  " style={{ marginLeft: '2em', marginRight: '2em', alignItems: 'center' }}>
            {path === '/inbasketpage' && <span className="ml-5 style_hover">My In-Basket</span>}
            {path === '/' && <span className="ml-5 style_hover">My In-Basket</span>}
            {path === '/filecode' && <span className="ml-5">Manage Record Schedule</span>}
            {path === '/scan' && <span className="ml-5 style_hover">File Intake</span>}
            {path === '/dashboard' && <span className="ml-5 style_hover">Dashboard</span>}
            {path === '/admin' && <span className="ml-5 style_hover">Administrator Panel</span>}
            {path === '/search' && <span className="ml-5 style_hover">Search</span>}
            {path === '/fileplan' && <span className="ml-5 style_hover">Create Retention Instruction</span>}
            {path === '/buow' && <span className="ml-5">BUOW Validation Page</span>}
            {path === '/routingsteps' && <span className="ml-5">Routing Steps</span>}
            {path === '/orchestration' && <span className="ml-5">Routing Orchestration</span>}
            {path === '/ruledefinition' && <span className="ml-5">Rule Definition</span>}
            {path === '/systemconfiguration' && <span className="ml-5">System Configuration</span>}
            {path === '/buowdisplayname' && <span className="ml-5">BUOW Display Name</span>}
            {path === '/userstable' && <span className="ml-5">Users</span>}
            {path === '/rolestable' && <span className="ml-5">Roles</span>}
            {path === '/permissionstable' && <span className="ml-5">Permissions</span>}
            {path === '/system-folder' && <span className="ml-5">System Folder</span>}
            {path === '/user-preference' && <span className="ml-5">User Preference</span>}
            {path === '/inbaskettable' && <span className="ml-5">In Basket</span>}
            {path === '/work-group' && <span className="ml-5">Work Group</span>}
            {path === '/messages' && <span className="ml-5">Message</span>}
            {path === '/profile' && <span className="ml-5">User Profile</span>}
            {path === '/buowtable' && <span className="ml-5">BUOW</span>}
            {path === '/ruletrigger' && <span className="ml-5">Rule Trigger</span>}
            {path === '/rule-log' && <span className="ml-5">Rule Log</span>}
            {path === '/unit-of-work' && <span className="ml-5">Unit of Work</span>}
            {path === '/workgroupuserxwalk' && <span className="ml-5">Work Group User Xwalk</span>}
            {path === '/object-hierarchy-table' && <span className="ml-5">Object Dictionary Object Hierarchy</span>}
            {path === '/elements' && <span className="ml-5">Elements</span>}
            {path === '/element-group' && <span className="ml-5">Element Group</span>}
            {path === '/redactionhistorytable' && <span className="ml-5">Redaction History</span>}
            {path === '/redaction-reference' && <span className="ml-5">Redaction Reference</span>}
            {path === '/objectdefinition' && <span className="ml-5">Object Dictionary Object Definition</span>}
            {path === '/objectdefinitiontable' && <span className="ml-5">Object Definition</span>}
            {path === '/redaction-actor' && <span className="ml-5">Redaction Actor</span>}
            {path === '/objectdictionaryobject' && <span className="ml-5">Object Dictionary Object</span>}
            {path === '/redaction-reason' && <span className="ml-5">Redaction Reason</span>}
            {path === '/objectdictionaryobjecttype' && <span className="ml-5">Object Dictionary Object Type</span>}
            {path === '/redactiondefinition' && <span className="ml-5">Redaction Definition</span>}
            {path === '/dashboard-indicators-dataSet-card-xref' && <span className="ml-5">Dashboard Indicators DataSet Card XRef</span>}
            {path === '/dashboard-indicator' && <span className="ml-5">Dashboard Indicator</span>}
            {path === '/dashboard-indicators-group' && <span className="ml-5">Dashboard Indicators Group</span>}
            {path === '/dashboard-card-benchmark-display' && <span className="ml-5">Dashboard Card Benchmark Display</span>}
            {path === '/dashboard-group-card-xref' && <span className="ml-5">Dashboard Group Card XRef</span>}
            {path === '/sec-role-dashboard-card-xref' && <span className="ml-5">Sec Role Dashboard Card Xref</span>}
            {path === '/indicators-data-set' && <span className="ml-5">Indicators Data Set</span>}
            {path === '/routingconditions' && <span className="ml-5">Routing Conditions</span>}
            {path === '/batchdefinition' && <span className="ml-5">Batch Definition</span>}
            {path === '/packager-preferred-order' && <span className="ml-5">Packager Preferred Order</span>}
            {path === '/packager-configuration' && <span className="ml-5">Packager Configuration</span>}
            {path === '/batch-xwalk' && <span className="ml-5">Batch Xwalk</span>}
            {path === '/holds' && <span className="ml-5">Manage Holds</span>}
            {path === '/transfer' && <span className="ml-5">Manage Transfers</span>}
            {path === '/manage' && <span className="ml-5">Manage Disposition</span>}
            {path.includes('/buow/') && buowDetails && <span className="ml-5">{buowDetails}</span>}
            {path === '/userguide' && (window.env.REACT_APP_GUIDE_VISIBLE === true || window.env.REACT_APP_GUIDE_VISIBLE === 'true') && <span className="ml-5">User Guide</span>}
            {path === '/elementgroupxwalk' && <span className="ml-5">Element Group Xwalk</span>}
            <div className="fsa-header-app__secondary">
              <div>
                <p
                  style={{
                    alignItems: 'right',
                    paddingBottom: '0em',
                    marginBottom: '0em',
                  }}
                >
                  <div
                    className="style_hover"
                    style={{ textTransform: 'capitalize', cursor: 'pointer', display: 'inline-block' }}
                    onClick={onSelectUserName}
                    tabIndex={0}
                    role="button"
                    aria-label={`User profile for ${loginUserName}`}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onSelectUserName();
                      }
                    }}
                  >
                    {loginUserName && loginUserName}
                  </div>{' '}

                  <div
                    className="style_hover"
                    onClick={loggingOut}
                    style={{ cursor: 'pointer', display: 'inline-block' }}
                    tabIndex={0}
                    role="button"
                    aria-label="Log out"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        loggingOut();
                      }
                    }}
                  >
                    {' |  Log out '}
                  </div>
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Head;
